import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {ButtonValidation, ButtonCancel} from '../../../../component/Button.js'

// Request Prop
import {UpdatePropsCancelBooking} from '../../request.props.js';

// Presenter
import {PresenterCancelBooking} from '../../../presenter.js'

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

export default class ModalCancelBooking extends React.Component {
  constructor(props) {
    // console.log('ModalCancelBooking constructor');
    super(props);

    this.state = {
      SelectedItem : this.props.self.state.SelectedItem,
      is_process   : false, 
    }

    this.cancelBooking = this.cancelBooking.bind(this)
    this.OnSuccsess = this.OnSuccsess.bind(this)
    this.OnFailed = this.OnFailed.bind(this)
  }

  cancelBooking() {
    this.setState({is_process: true})
    PresenterCancelBooking(
      UpdatePropsCancelBooking(this, this.OnSuccsess, this.OnFailed)
    )
  }

  OnSuccsess(params, response){
    this.setState({is_process: false})
    toast.success("Cancel booking success")
    params.self.props.self.updateRow(response.data);
  }

  OnFailed(params, response){
    this.setState({is_process: false})
    toast.error(params.statusText + " #"+ params.status);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(nextProps.self.state.SelectedItem !== null) {
      nextState.SelectedItem = nextProps.self.state.SelectedItem;
    }
    return true;
  }

  render() {
    const {is_process} = this.state

    if (this.state.SelectedItem == null ) return null

    return (
      <Modal isOpen={this.props.self.state.modal.CancelBooking} toggle={() => this.props.self.toggleModalCancelBooking(null)} >
        <ModalHeader toggle={() => this.props.self.toggleModalCancelBooking(null)}>Cancel Booking Tools</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="form-group col-sm-12">
              <label htmlFor="asset">Asset / Tools</label>
              <input type="text" className="form-control" id="asset" value="Drum (D787FF79AF6F479 )" disabled/>
            </div>
            <div className="form-group col-sm-6">
              <label htmlFor="site">Site</label>
              <input type="text" className="form-control" id="site" value={this.state.SelectedItem.Site.Name} disabled/>
            </div>
            <div className="form-group col-sm-6">
              <label htmlFor="location">Location</label>
              <input type="text" className="form-control" id="location" value={this.state.SelectedItem.Location.Name} disabled/>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonCancel onClick={()=>this.props.self.toggleModalCancelBooking(null)}>Close</ButtonCancel>
          <ButtonValidation is_process={is_process} onClick={()=>this.cancelBooking()} disabled={this.state.disabled}>Cancel Booking</ButtonValidation>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/home/helper/component/Modal/ModalCancelBooking.js